<template>
  <Dialog
    v-model:visible="isLoading"
    modal
    :closable="false"
    :showHeader="false"
    :autoZIndex="false"
    :style="{ background: 'transparent', boxShadow: 'none' }"
    contentClass="m-loader-dialog"
  >
    <div class="m-loader">
      <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" animationDuration=".5s" />
      <span v-if="loadingText" class="m-loader__text">
        {{ loadingText }}
      </span>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import Dialog from 'primevue/dialog'
import ProgressSpinner from 'primevue/progressspinner'
import { computed } from 'vue'

const appStore = useAppStore()

const isLoading = computed(() => appStore.isLoading)
const loadingText = computed(() => appStore.loadingText)
</script>

<!-- unscoped: Dialog mask teleported to body; fixed layer below Messages.* -->
<style lang="scss">
body > .p-dialog-mask:has(.m-loader) {
  z-index: 1100 !important;
}

body > .p-dialog-mask:has(.m-loader) .p-dialog {
  z-index: 1101 !important;
}
</style>

<style scoped lang="scss">
.m-loader-dialog {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

:deep(.p-dialog-content) {
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
}

.m-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
}

.m-loader__text {
  color: #ffffff;
  font-size: 1rem;
  text-align: center;
}

:deep(.p-dialog-mask) {
  background-color: rgba(0, 0, 0, 0.4);
}

:deep(.p-dialog) {
  .p-dialog-content {
    background: transparent;
    border: none;
    padding: 0;
  }
}
</style>
